module.exports = __webpack_public_path__ + "img/vac-h.9009fe38.svg";